import { ThemeProvider } from "@mui/material"
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Theme from '../../layouts/theme-onboarding/Theme';
import CardProduct from "../../components/product/CardProduct";
import Header from "../../layouts/Header";
import Storage from "../../services/Storage";

export default function Product() {
    const navigate = useNavigate();

  useEffect(() => {
    if (Storage.getLocalAccessToken() !== null) {
      navigate('/dashboard', {replace: true})
    }
  }, [navigate]);
  
    return (
      <div>
        <Header></Header>
        <ThemeProvider theme={Theme}>
            <CardProduct />
        </ThemeProvider>
      </div>
    )
}